import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_5842_1982)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_5842_1982)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M8.66732 4L12.6673 8L8.66732 12V8V4Z",
				fill: "#363636"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M3.33398 8H12.6673M12.6673 8L8.66732 4V12L12.6673 8Z",
				stroke: "#363636",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5842_1982",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_5842_1982",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
			fill: "white"
		})
	})] })]
});
export default SvgFilledArrow;
